import React, { Component } from 'react'
import styled from 'styled-components'
import { graphql } from 'react-apollo'
import LoadingButton from '../common/LoadingButton'
import UpdateDocumentComment from './queries/UpdateDocumentComment'

const Container = styled.div`
  margin-bottom: 20px;
`
const Save = styled(LoadingButton)`
  background: #75AFB6;
  margin-right: 3px;
  padding: 5px 20px;
`
const Cancel = styled.a`
  cursor: pointer;
  color: #75AFB6;
  margin-left: 3px;
  &:hover {
    color: #75AFB6;
  }
`
const Controls = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
const TextArea = styled.textarea`
  width: calc(100% - 14px); /* account for default padding + border */
  resize: vertical;
`

const Icon = styled.i`
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #bd6228;
  color: white;
  visibility: hidden;
  padding: 3px;
  margin-left: 4px;
  cursor: pointer;
  display: inline-block;
`

const NoteContainer = styled.div`
  margin-bottom: 20px;
`
const NotePencil = Icon.extend`
  ${NoteContainer}:hover & {
    display: inline;
    visibility: visible;
  }
`

const AddNote = styled.a`
  color: #75AFB6;
  cursor: pointer;
  &:hover {
    color: #75AFB6;
  }
`

class Note extends Component {
  constructor(props) {
    super(props)
    const { comment } = props.document
    this.state = {
      comment,
      isLoading: false,
      isOpen: false
    }
  }
  componentWillMount() {
    this.prepareComment()
  }
  componentDidUpdate(prevProps) {
   const { comment } = prevProps.document
   const { comment: newComment } = this.props.document
   if ( comment !== newComment) {
     this.setState({ comment: newComment })
   }
  }
  generateHash = referenceFiles => {
    const arrComments = []
    referenceFiles.forEach(({ date }) => {
      const key = this.props.getKeyRef(date)
      const hash = { dateRef: key, comment: null}
      arrComments.push(hash)
    })
    return JSON.stringify(arrComments)
  }
  updateHash = (referenceFiles, comment) => {
    const arrComments = []
    const oldComments = JSON.parse(comment)
    const dateKeys = referenceFiles.map(({ date }) => ( this.props.getKeyRef(date) ))
    dateKeys.forEach(keyword => {
      const oldComment = oldComments.find(({ dateRef }) => dateRef === keyword)
      const hash = { dateRef: keyword, comment: oldComment ? oldComment.comment : null }
      arrComments.push(hash)
    })
    return JSON.stringify(arrComments)
  }
  prepareComment = () => {
    const { referenceFiles } = this.props
    let { comment } = this.state
    if (referenceFiles.length > 0) {
      comment = !comment ? this.generateHash(referenceFiles) : this.updateHash(referenceFiles, comment)
    }
    this.setState({ comment })
  }
  getComment = reference => {
    let { comment } = this.state
    if (!reference || !comment) {
      return comment
    }
    const { date } = reference
    const key = this.props.getKeyRef(date)
    return JSON.parse(comment).find(({ dateRef }) => dateRef === key).comment
  }
  onChange = ({ target }) => {
    let { value: targetComment } = target
    let comment = targetComment
    const { reference } = this.props
    if (reference) {
      const { comment: oldComment } = this.state
      const newComments = []
      const { date } = reference
      const key = this.props.getKeyRef(date)
      JSON.parse(oldComment).forEach(refDate => {
        const { dateRef } = refDate
        if (dateRef === key) {
          refDate.comment = targetComment
        }
        newComments.push(refDate)
      })
      comment = JSON.stringify(newComments)
    }
    this.setState({ comment })
  }
  toggleState = state => {
    this.setState({
      [state]: !this.state[state]
    })
  }
  onSave = async () => {
    const { updateDocumentComment, updateDocumentData, document: doc } = this.props
    const { rid: documentId } = doc
    const { comment } = this.state
    if (comment) {
      await this.toggleState('isLoading')
      try {
        await updateDocumentComment({
          variables: {
            input: {
              documentId,
              comment
            }
          },
          update: (store, { data: { updateDocumentComment: { document } } }) => {
            updateDocumentData(document, store)
          }
        })
        this.toggleState('isOpen')
        this.toggleState('isLoading')
      } catch (err) {
        console.log(err)
      }
    }
  }
  renderOpenNote = () => {
    const { reference } = this.props
    const comment = this.getComment(reference)
    const { isLoading } = this.state
    const placeholder = `Please add any additional comments to the borrower. This will appear on the borrower\'s document uploads page and the document status update email.`
    return (
      <Container id="edit_borrower_note_container">
        <div>
          <b>Note to Borrower</b>
        </div>
        <TextArea
          maxLength="255"
          defaultValue={comment}
          onChange={this.onChange}
          placeholder={placeholder}
          id="comment_text_area"
        />
        <Controls>
          <Save onClick={this.onSave} loading={isLoading} id="save_comment_button" disabled={isLoading}>
            Save Comment
          </Save>
          <span>
            or
          </span>
          <Cancel onClick={() => this.toggleState('isOpen')} id="cancel_comment_button">
            Cancel
          </Cancel>
        </Controls>
      </Container>
    )
  }
  renderAddNote = rid => {
    return (
      <AddNote id={`add_borrower_note_link_${rid}`} onClick={() => this.toggleState('isOpen')}>
        + Add note to Borrower
      </AddNote>
    )
  }
  renderComment = () => {
    const { document: doc, reference } = this.props
    const { rid } = doc
    return (
      <NoteContainer>
        <b>
          Note to Borrower
          <NotePencil id="edit_note" documentId={rid} onClick={() => this.toggleState('isOpen')}
              className="fa fa-pencil"
            />
        </b>
        <p>{this.getComment(reference)}</p>
      </NoteContainer>
    )
  }
  renderCommentContainer = () => {
    const { document: doc, reference } = this.props
    const { rid, status } = doc
    const { isOpen } = this.state
    const comment = this.getComment(reference)
    let shouldRender = ['pending_review', 'rejected'].includes(status)
    if (reference) {
      const { status: referenceStatus } = reference
      shouldRender = ['pending_review', 'rejected'].includes(referenceStatus)
    }
    if (isOpen ) {
      return this.renderOpenNote() 
    } else if (shouldRender) {
      return !comment ? this.renderAddNote(rid) : this.renderComment()
    } 
    return ''
  }
  render() {
    const { document: doc, canComment } = this.props
    const { displayCommentable } = doc
    return (
      canComment && displayCommentable ? this.renderCommentContainer() : ''
    )
  }
}
export default graphql(UpdateDocumentComment, {
  name: 'updateDocumentComment'
})(Note)
